import React from 'react';

interface AdminStatCardProps {
  icon: React.ReactNode;
  title: string;
  value: number | string;
  isLoading?: boolean;
}

export const AdminStatCard: React.FC<AdminStatCardProps> = ({ icon, title, value, isLoading }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-2 rounded-xl border-2 border-[#D1DBFD] bg-[#E9EDFE] p-5">
      <div className="text-[#6b8af9]">{icon}</div>
      <p className="font-hanken text-3xl font-semibold text-[#061A61]">
        {isLoading ? '...' : value}
      </p>
      <p className="font-hanken text-sm font-medium text-[#555661]">{title}</p>
    </div>
  );
};
